import {
	listRefundRequests, approveRefundRequest, rejectRefundRequest,
} from '@/services/academy/refundRequests.service'

export default {
	namespaced: true,
	state: {
		list: { data: [], meta: { total: 0 } },
		listStatus: 'init',
		actionStatus: 'init',
	},
	getters: {
		getList: (s) => s.list,
		getListStatus: (s) => s.listStatus,
		getActionStatus: (s) => s.actionStatus,
	},
	mutations: {
		SET_LIST(state, v)          { state.list = v },
		SET_LIST_STATUS(state, v)   { state.listStatus = v },
		SET_ACTION_STATUS(state, v) { state.actionStatus = v },
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await listRefundRequests(params)
				commit('SET_LIST', data)
				commit('SET_LIST_STATUS', 'init')
			} catch {
				commit('SET_LIST_STATUS', 'error')
			}
		},
		async approve({ commit, dispatch }, { id, notes }) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				await approveRefundRequest(id, { admin_notes: notes })
				commit('SET_ACTION_STATUS', 'success')
				dispatch('fetchList')
			} catch (e) {
				commit('SET_ACTION_STATUS', 'error')
				throw e
			}
		},
		async reject({ commit, dispatch }, { id, notes }) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				await rejectRefundRequest(id, { admin_notes: notes })
				commit('SET_ACTION_STATUS', 'success')
				dispatch('fetchList')
			} catch (e) {
				commit('SET_ACTION_STATUS', 'error')
				throw e
			}
		},
	},
}
